export default "dist/images/block-team-member-horizontal.b1c9ed6.png";